<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Paxel.co Dashboard</h5>
      <br />
    </div>
    <b-row>
      <b-col md="12">
        <b-card class="text-left">
          <b>Input Paxel.co Dashboard</b>
          <b-row class="mt-4">
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Users"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.number_of_users"
                  name="number_of_users"
                  id="input-1"
                  data-vv-as="Users"
                  class="form-control"
                  placeholder="Users"
                />
                <b-form-invalid-feedback
                  id="input-number_of_users-feedback"
                >{{ veeErrors.first('number_of_users') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Total Shipments"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.total_shipments"
                  name="total_shipments"
                  id="input-1"
                  data-vv-as="Total Shipments"
                  class="form-control"
                  placeholder="Total Shipments"
                />
                <b-form-invalid-feedback
                  id="input-total_shipments-feedback"
                >{{ veeErrors.first('total_shipments') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="On Time Delivery"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="items.on_time_delivery"
                  name="on_time_delivery"
                  id="input-1"
                  data-vv-as="On Time Delivery"
                  class="form-control"
                  placeholder="On Time Delivery"
                />
                <b-form-invalid-feedback
                  id="input-on_time_delivery-feedback"
                >{{ veeErrors.first('on_time_delivery') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Coverage Area (Bahasa)"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <ckeditor
                    :editor="editor"
                    tag-name="textarea"
                    placeholder="Coverage Area (Bahasa)"
                    v-model="items.coverage.id"
                    data-vv-as="Coverage Area (Bahasa)"
                    v-validate="'required'"
                    name="coverage_id"
                    class="form-control"
                    :config="editorConfig"
                  ></ckeditor>
                  <p
                    class="text-danger"
                    style="width:100%;margin-top:.25rem;font-size: 80%;"
                  >{{ veeErrors.first('coverage_id') }}</p>
                </b-form-group>
            </b-col>
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Coverage Area (English)"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <ckeditor
                    :editor="editor"
                    tag-name="textarea"
                    placeholder="Coverage Area (English)"
                    v-model="items.coverage.en"
                    data-vv-as="Coverage Area (English)"
                    v-validate="'required'"
                    name="coverage_en"
                    class="form-control"
                    :config="editorConfig"
                  ></ckeditor>
                  <p
                    class="text-danger"
                    style="width:100%;margin-top:.25rem;font-size: 80%;"
                  >{{ veeErrors.first('coverage_en') }}</p>
                </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="2" class="text-left">
              <label class="text-danger">
                *
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
                Save
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-show="!image" v-if="items.image" width height="400px" :src="items.image" />
      <img v-show="image" v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";

export default {
  mixins: [mixInCkeditor],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      widthImage: null,
      heightImage: null,
      loading: false,
      items: [],
      urlImage: "",
      modalImage: false,
      image: ""
    };
  },
  beforeCreate() {
    this.$store.dispatch("PaxelcoDashboardModule/getPaxelcoDashboard");
  },
  created() {
    this.$store.watch(
      state => state.PaxelcoDashboardModule.paxel_dashboard,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Paxel.co Dashboard!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              var coverage_id = this.$options.filters.CkEditor(this.items.coverage.id);
              var coverage_en = this.$options.filters.CkEditor(this.items.coverage.en);
              formData.append("number_of_users", this.items.number_of_users);
              formData.append("on_time_delivery", this.items.on_time_delivery);
              formData.append("total_shipments", this.items.total_shipments);
              formData.append("coverage_id", coverage_id);
              formData.append("coverage_en", coverage_en);
              this.$store
                .dispatch(
                  "PaxelcoDashboardModule/postPaxelcoDashboard",
                  formData
                )
                .then(response => {
                  this.loading = false;
                  this.$validator.reset();
                  this.$router.push({ name: "PaxelcoDashboard" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your file cant be submit.", "warning");
            }
          });
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
